export default function Sustainability() {
  return (
    <section
      className="elementor-section elementor-top-section elementor-element elementor-element-0295238 elementor-section-full_width elementor-reverse-tablet elementor-reverse-mobile elementor-section-height-default elementor-section-height-default"
      data-id="0295238"
      data-element_type="section"
    >
      <div className="elementor-container elementor-column-gap-no">
        <div
          className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-073c597"
          data-id="073c597"
          data-element_type="column"
        >
          <div className="elementor-widget-wrap elementor-element-populated">
            <section
              className="elementor-section elementor-inner-section elementor-element elementor-element-dff3cbe elementor-section-boxed elementor-section-height-default elementor-section-height-default"
              data-id="dff3cbe"
              data-element_type="section"
            >
              <div className="elementor-container elementor-column-gap-default">
                <div
                  className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-ba8893b"
                  data-id="ba8893b"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-f47c912 elementor-widget elementor-widget-heading"
                      data-id="f47c912"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h2 className="elementor-heading-title elementor-size-default">
                          Environmental Management Systems (ISO 14001)
                        </h2>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-f54bbd7 elementor-widget elementor-widget-text-editor"
                      data-id="f54bbd7"
                      data-element_type="widget"
                      data-widget_type="text-editor.default"
                    >
                      <div className="elementor-widget-container">
                        <p>
                          Responsible for the design and implementation of an
                          environmental management system that applies to every
                          business looking to monitor its environmental duties
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-7fb3c4f"
                  data-id="7fb3c4f"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-d1e34eb elementor-widget elementor-widget-heading"
                      data-id="d1e34eb"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h2 className="elementor-heading-title elementor-size-default">
                          Energy Management Systems (ISO 50001)
                        </h2>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-23093b1 elementor-widget elementor-widget-text-editor"
                      data-id="23093b1"
                      data-element_type="widget"
                      data-widget_type="text-editor.default"
                    >
                      <div className="elementor-widget-container">
                        <p>
                          Created to help organizations to develop policies in
                          order to use energy more effectively and additionally,
                          create targets and objectives to meet the policy
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>

        <div
          className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-70eb217"
          data-id="70eb217"
          data-element_type="column"
        >
          <div className="elementor-widget-wrap elementor-element-populated">
            <div
              className="elementor-element elementor-element-34b3ce8 elementor-widget elementor-widget-heading"
              data-id="34b3ce8"
              data-element_type="widget"
              data-widget_type="heading.default"
            >
              <div className="elementor-widget-container">
                <h2 className="elementor-heading-title elementor-size-default">
                  Sustainability
                </h2>
              </div>
            </div>
            <div
              className="elementor-element elementor-element-8a43179 elementor-widget elementor-widget-text-editor"
              data-id="8a43179"
              data-element_type="widget"
              data-widget_type="text-editor.default"
            >
              <div className="elementor-widget-container">
                Just as your company is doing the right thing for its business,
                we’ll help you ensure that you’re playing your part for the
                environment as well
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
